export const FILE_FORM_ID = 672
export const ATTACHMENT_FIELD_NAME = 'Attachment'
